/**
 * Settings → Reminders — prototype VIEWS.settings, ST.tab==='notif' (docs/prototype.html L4434): one panel, at most
 * 620px wide, one row and switch per channel.
 *
 * Nothing on this tab is a stored setting yet, so it shows how v1 actually reaches people instead of switches that
 * save nothing. ADR-001 §10 ("Outbound email / push: deferred, in-app notifications only"):
 *  - In-app notifications: on (GET /notifications, the bell).
 *  - Email, and phone notifications from the installed web app: not in this version.
 *  - WhatsApp: links that open WhatsApp with the message written (wa.me, no Business API) that the Ops associate
 *    director sends by hand. Always available.
 * The prototype's "Morning digest time" and "Daily update time" belong to the deferred sends. The Daily update is a
 * live page under Team, so there is no send time to set. When email or push is built, these rows become real
 * switches backed by a settings endpoint.
 */
import { Switch } from '../../ui/kit';

const CHANNELS: { label: string; on: boolean; note: string }[] = [
  { label: 'In-app notifications', on: true, note: 'Always on. The bell at the top shows everything meant for you.' },
  { label: 'Email', on: false, note: 'Not in this version. Ops is in-app first.' },
  { label: 'Phone notifications from the installed web app', on: false, note: 'Not in this version. Ops is in-app first.' },
  {
    label: 'WhatsApp links the Ops associate director sends by hand',
    on: true,
    note: 'Always available. The message is written for you, and WhatsApp opens to send it.',
  },
];

export function Reminders() {
  return (
    <div className="panel">
      <div className="bd" style={{ display: 'grid', gap: 16, maxWidth: 620 }}>
        {CHANNELS.map((c) => (
          <div className="split" key={c.label}>
            <div className="grow">
              <b>{c.label}</b>
              <div className="sub" style={{ color: 'var(--sub)', fontSize: 12.5 }}>
                {c.note}
              </div>
            </div>
            <Switch on={c.on} onClick={() => undefined} label={`${c.label} (${c.on ? 'on' : 'off'}, fixed in this version)`} disabled />
          </div>
        ))}
        <div className="note" style={{ margin: 0 }}>
          The Daily update (what was done today, for the Ops associate director, founders and each person) is a live page under
          Team, built from timesheets and closed tasks. Nothing is sent on a timer in this version, so there is no digest time to
          set.
        </div>
      </div>
    </div>
  );
}
